import {Image} from "@/images/Image.ts";
import type {CharacterSenses} from "./CharacterSenses.ts";

export interface Character {
    id: string
    name: string
    hitPoints: HitPoints
    armorClass: ArmorClass
    speeds: Speeds
    senses: CharacterSenses
    challenge: number
    xp?: string
    source?: string
    hostile: boolean

    // profile
    image?: Image
    alignment?: string
    languages: string[]
    size: string
    type?: string
    race?: string
    classes?: string[]

    // attributes
    attributes: Attribute[]
    skills?: string[]
    damageResistances?: string[]
    damageVulnerabilitys?: string[]
    damageImmunitys?: string[]
    conditionImmunitys?: string[]

    // actions
    actions: Action[]

    // spells
    spellcasting?: Spellcasting | null

    // auditing
    createdAt?: Date
    updatedAt?: Date

}

export interface CharacterSummary {
    id: string
    name: string
    image?: Image
    type: "CHARACTER"
    hitPoints: number
    challenge: number
    hostile: boolean
}

export interface ArmorClass {
    value: number
    info?: string
}

export interface HitPoints {
    value: number
    formula?: string
}

export interface Speeds {
    walk: string
    swim?: string
    climb?: string
    fly?: string
    burrow?: string
}

export interface Attribute {
    stat: AttributeStat
    value: number
    modifier: number
    save: number
}

export interface Action {
    name: string
    value: string
    type: ActionType
}

export const SPELLCASTING_TYPES = ['Klasse', 'Angeboren'] as const;
export type SpellcastingType = typeof SPELLCASTING_TYPES[number];


export interface Spellcasting {
    type: SpellcastingType;
    attribute?: AttributeStat;
    saveDc?: number;
    skill?: number;
    description?: string;
    spellGroups: SpellGroup[];
}


export interface SpellGroup {
    level?: number;   // nur wenn groupType === 'LEVEL'
    frequency?: string;    // nur wenn groupType === 'FREQUENCY'
    slots?: number;
    spells: SpellReference[];
}

export interface SpellReference {
    id: string
    name: string
    image?: Image
}

export const ACTION_TYPES = ["Action", "Reaction", "Trait", "Legendary"] as const;
export type ActionType = typeof ACTION_TYPES[number];

export const ATTRIBUTE_STATS = ["str", "dex", "con", "int", "wis", "cha"] as const;
export type AttributeStat = typeof ATTRIBUTE_STATS[number];
